import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Form, Select } from 'antd';
import PropTypes from "prop-types";
import {
    WrapLabel,
    LabelWrapper,
    SelectOptionWrapper,
    SelectOptionGraded,
    InputWrapperGraded,
    InputWrapper,
    GrantAgreementDropdown,
    HideArrow,
} from "../../ContributionType/styles";
import { Rules } from "../Rules/Rules";
import { changeAddressValue,updateContributionStatus, updateErrorMessage } from "../../../actions";

class AddressInputDropDown extends React.Component {
    constructor(props) {
        super(props);
        this.onDropdownChange= this.onDropdownChange.bind(this);
    }

    componentDidUpdate(nextProps){
      if(nextProps.value !== this.props.value ){
        let id = 'addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId;
        let value = {};
        value[id] =  this.props.value;
        this.props.form.setFieldsValue(value);
        if(this.props.value !== '' && nextProps.value)
        this.props.form.validateFields();
      }  
   }

   componentWillReceiveProps(nextProps){
    let id = 'addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId;
    let value = {};
      if(nextProps.value !== this.props.value && this.props.isSameAddress){
        value = {};
        value[id] =  this.props.value === "" ? undefined : this.props.value ;
        this.props.form.setFieldsValue(value);
        this.props.form.validateFields();
      }  
      if(this.props.donorId && (this.props.assetHeld === nextProps.showErrorMessage.assetHeld) && nextProps.showErrorMessage.inputDropDown){
          value = {};
          value[id] =  this.props.value;
          this.props.form.setFieldsValue(value);
          this.props.form.validateFields();
          if((this.props.accountId ) === this.props.giftLength && 
              ((this.props.countryValue === "United States" && this.props.property === "state") || (this.props.countryValue !== "United States" && this.props.property === "country"))){
            if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected))
            this.props.updateErrorMessages({type: 'inputDropDown'});
          }
          if((this.props.accountId + 1) === this.props.giftLength){
            if(this.props.property === 'country'){
              if(this.props.accountInfo[this.props.accountId + 1]['type'] === 'Select Account Type'){
                if(!(['assetHeldatVG','assetOutsideVG'].includes(this.props.assetHeld) && this.props.contributionType === 'mutualFund' && this.props.isSecuritySelected)){
                  this.props.updateErrorMessages({type: 'inputDropDown'});
                }
              }
            }
          }
      }
   }

    onDropdownChange = (e) => {
        if(this.props.donorId > 0) this.props.changeAddress(e);
        this.props.updateContributionStatus();
        let name='addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId;
        let setfield={}
        setfield[name]=e;
        this.props.form.setFieldsValue(setfield);
        this.props.form.validateFields();
    
    }
    onDropdownBlur = (e) => {   
      let name='addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId;
      let setfield={}
      setfield[name]=e;
      this.props.form.setFieldsValue(setfield);
      this.props.form.validateFields();
        
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { Option } = Select;
        let dropDownValues = [];
        if(this.props.property === "country"){
            dropDownValues = this.props.dropdownVal ? this.props.dropdownVal.countries : [];
        }else{
            dropDownValues = this.props.dropdownVal ? this.props.dropdownVal.states : [];
        }
        let dropDownValue = (this.props.value === "") ? undefined : this.props.value;
        return (

<HideArrow>
<WrapLabel>
  <Form.Item colon={false} label={<LabelWrapper>{this.props.label}</LabelWrapper>}>
  {getFieldDecorator('addressdropdownDataID' + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId, {
                        rules: Rules[this.props.property]?Rules[this.props.property].rules:"",
                    })(
      (this.props.donorId === 0) ?
      <InputWrapperGraded>
      <SelectOptionGraded>                 
      <InputWrapper className="mbPoint75">
        <div className="relative" id={"addressdropdownData" + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId} >
          <GrantAgreementDropdown onChange={e => this.onDropdownChange(e)}
            aria-labelledby={this.props.property}
            role="list"
            value={this.props.loggedInValue} placeholder={"Select the " + this.props.label} disabled
            getPopupContainer={() => document.getElementById("addressdropdownData" + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId)}
          >
            {dropDownValues.map((dValue, index) => { return (<Option value={dValue.desc} ><SelectOptionWrapper>{dValue.desc}</SelectOptionWrapper></Option>) })}
          </GrantAgreementDropdown>
        </div>
      </InputWrapper>
      </SelectOptionGraded>   
      </InputWrapperGraded>
      :
      <InputWrapper>
        <div className="relative" id={"addressdropdownData" + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId} >
          <GrantAgreementDropdown  
            aria-labelledby={this.props.property}
            role="list"
            onChange={e => this.onDropdownChange(e)}
            onBlur ={e => this.onDropdownBlur(e)}
            value={dropDownValue} placeholder={"Select the " + this.props.label.toLowerCase()} showSearch="true"
            getPopupContainer={() => document.getElementById("addressdropdownData" + this.props.accountId + this.props.contributionType + this.props.assetHeld + this.props.property + this.props.donorId)}
          >
            {dropDownValues.map((dValue, index) => { return (<Option value={dValue.desc} ><SelectOptionWrapper>{dValue.desc}</SelectOptionWrapper></Option>) })}
          </GrantAgreementDropdown>
        </div>
      </InputWrapper>
    )}
  </Form.Item>
</WrapLabel>
</HideArrow>
        )
    }

}

const WrappedAddressInputDropDown = Form.create({ name: "addressDropdown" })(AddressInputDropDown);

WrappedAddressInputDropDown.propTypes = {
  value: PropTypes.string,
  countryValue: PropTypes.string,
  isSameAddress: PropTypes.bool,
  dropdownVal : PropTypes.array,
  showErrorMessage: PropTypes.object,
  accountInfo: PropTypes.object,
  isDummyUpdated: PropTypes.bool,
  isSecuritySelected: PropTypes.bool,
  loggedInValue: PropTypes.string,
  changeAddress: PropTypes.func,
  updateContributionStatus: PropTypes.func,
  updateErrorMessages: PropTypes.func,
}

const mapStateToProps = (state,ownProps) => ({
    value: state.getIn(["makeAContribution", "contributionTypes" , `${ownProps.assetHeld}`, `${ownProps.contributionType}`, `${ownProps.accountId}`, "Donors", `${ownProps.donorId}`, "Address" ,`${ownProps.property}` ]),
    countryValue: state.getIn(["makeAContribution", "contributionTypes" , `${ownProps.assetHeld}`, `${ownProps.contributionType}`, `${ownProps.accountId}`, "Donors", `${ownProps.donorId}`, "Address" ,'country' ]),
    isSameAddress: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,`${ownProps.contributionType}`,`${ownProps.accountId}`,"Donors",`${ownProps.donorId}`,'isSameAddress']),
    dropdownVal : state.getIn(["makeAContribution","apiData","dropdownData","data"]),
    showErrorMessage: state.getIn(["makeAContribution","contributionTypes",'showErrorMessage']),
    accountInfo: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`, `${ownProps.contributionType}`]),
    isDummyUpdated: state.getIn(["makeAContribution", "contributionTypes", "dummyUpdate"]),
    isSecuritySelected: state.getIn(["makeAContribution","contributionTypes",`${ownProps.assetHeld}`,'sgSelected']),
    loggedInValue: state.getIn(['makeAContribution','apiData', 'loggedInAddress','data','Address',`${ownProps.property}`])
});

export const mapDispatchToProps = (dispatch, ownProps) => ({
    changeAddress: e => dispatch(changeAddressValue({value:e, property:ownProps.property, accountId:ownProps.accountId, contributionType:ownProps.contributionType, assetHeld: ownProps.assetHeld, donorId: ownProps.donorId })),
    updateContributionStatus: () => dispatch(updateContributionStatus({value:false,assetHeld: ownProps.assetHeld})),
    updateErrorMessages: data => dispatch(updateErrorMessage(data))
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedAddressInputDropDown));
